import { BrowserRouter } from "react-router-dom";
import ReactRoute from "./ReactRoute";



const ReactRouter = () => {
    return (
        <>
            <BrowserRouter>
                <ReactRoute />
            </BrowserRouter>
        </>
    )
}

export default ReactRouter;



// .